import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import "./HomeStyle.css";
import Contact from "./ContactInfoSection/Contact";
import Projects from "./ProjectsSection/Projects";
import Services from "./ServicesSection/Services";
import ContactSection from "./ContactSection/ContactSection";
import Footer from "./FooterSection/Footer";
import About from "./AboutSection/About";

const Home = () => {
  const { i18n } = useTranslation();

  return (
    <>
      <section className="home-section" id="home">
        <div className="home-overlay"></div>
        <div className="container home-content" dir="ltr">
          <h1 className="vision-text">
            <span className="vision-main">Realizing Visions</span>
            <br />
            <span className="vision-by">by</span>
            <span
              className={
                i18n.language === "en" ? "dancing-script" : "vision-name"
              }
            >
              Ali Eldeeb
            </span>
          </h1>
        </div>
      </section>
      <Contact id="contact" />
      <About id="about" />
      <Projects id="projects" />
      <Services id="services" />
      <ContactSection id="contact" /> <Footer />
    </>
  );
};

export default Home;
